export default __webpack_public_path__ + "img/favicons/apple-touch-icon-76x76.png";